/*
We will create ActionCreators which are functions that return action objects with two parameters :-

type : Used to identify the type of action we are sending. It is also used to differentiate between multiple actions.
payload : Used to hold any data that might be required to accompany the object.

*/
import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';
import { SubmissionError } from 'redux-form';
import diff from 'object-diff';
import { updateCustomerDebt } from '../People/actions';
import * as _ from 'lodash';
//import LocalStorage from '../../api/LocalStorage';

//THUNK
export function loadMonth(month, dotsOnly = false) {
	return function(dispatch, getState) {
		//const authToken = getState().loginReducer.user.access_token;
		const jwt = getState().loginReducer.jwt.token; //expiresd?
		//console.log('got authToken in actions ', authToken);
		//dispatch(listIsLoading(true));
		const currentEntries = getState().dailyEntriesReducer.entries;

		CalCalDataApi.dataLoad('dailyEntries/monthEntries/' + month, jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (!res.error) {
				dispatch({
					type: 'DE_ENTRIES_LOADED',
					entries: res
				});
			} else {
				dispatch({
					type: 'DE_ENTRIES_ERROR',
					error: res.error
				});
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	};
}

export function deleteTrans(item, series) {
	return function(dispatch, getState) {
		const jwt = getState().loginReducer.jwt.token; //expiresd?
		const seriesPath = series ? '/series' : '';
		console.log('delete item', item, series, seriesPath);
		CalCalDataApi.dataDelete('dailyEntries/' + item.transaction_type + '/' + item.real_id + seriesPath, jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (res.status == 200) {
				dispatch({
					type: 'DELETE/dailyEntry',
					id: item.real_id,
					origDate: item.expenseDate,
					transType: item.transaction_type,
					origItem: item
				});
				dispatch(updateDayTotals(item.expenseDate));
				if (res.customer_id) dispatch(updateCustomerDebt(res.customer_id));
			} else if (res.status == 226) {
				//marked void
				dispatch({
					type: 'UPDATE/dailyEntry',
					origDate: item.expenseDate,
					id: item.real_id,
					transType: item.transaction_type,
					difference: res.difference
				});
				dispatch(updateDayTotals(item.expenseDate));
				if (res.customer_id) dispatch(updateCustomerDebt(res.customer_id));
			} else {
				dispatch({
					type: 'DE_ENTRIES_ERROR',
					error: res.error
				});
				Alert.alert(res.title, 'Cannot delete entry. \n' + res.error);
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	};
}

export function updateDayTotals(date) {
	return function(dispatch, getState) {
		const jwt = getState().loginReducer.jwt.token; //expiresd?
		CalCalDataApi.dataLoad('dailyEntries/dayTotals/' + date, jwt, res => {
			if (!res.error)
				dispatch({
					type: 'loadDayTotals',
					date,
					dayTotals: res
				});
			//ignore errors we'll just have a blank
		});
	};
}

export function loadCustomersTrans(custId) {
	return function(dispatch, getState) {
		//const authToken = getState().loginReducer.user.access_token;
		const jwt = getState().loginReducer.jwt.token; //expiresd?
		//console.log('got authToken in actions ', authToken);
		//dispatch(listIsLoading(true));

		CalCalDataApi.dataLoad('dailyEntries/byCustomer/' + custId, jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (!res.error) {
				dispatch({
					type: 'DE_CUSTINVS_LOADED',
					entries: res
				});
			} else {
				dispatch({
					type: 'DE_CUSTINVS_ERROR',
					error: res.error
				});
			}
		});
	};
}

/*

eg

// Thunk function, it calls the getRepos action above after it receives the fetch response.
export function getRepoThunk() {
  return function(dispatch, getState) {
    fetch('https://api.github.com/repositories')
    .then(e => e.json())
      .then(function(response){
        console.log(response);
        var arr = response.slice(0,10);
        dispatch(getRepos(arr))
      })
      .catch((error) => {
        console.error(error,"ERRRRRORRR");
      });
  }
}
// Repo selected action
export function repoSelected(repo){
  return{
    type: 'Repo_Selected',
    payload: repo
  }
}

*/
